var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-card"},[_c('img',{attrs:{"data-click-event":_vm.EnumDataTracking.ClickImageCard,"data-click-args":_vm.img,"src":_vm.img,"alt":_vm.alt}}),_c('h3',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }